import ChatRoomJoin from "./ChatRoomJoin";

function ChatApp() {
  // console.log("rendering ChatApp component");

  return (
    <div className="d-flex flex-column align-items-center">
      <ChatRoomJoin />
    </div>
  );
}

export default ChatApp;
